import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const API_BASE = 'http://localhost:8080/api/User';

  const handleLogin = async (e) => {
  e.preventDefault();
  setError('');

  // ✅ Local default login (for testing without server)
  if (username === 'admin' && password === '1234') {
    const user = {
      username: 'admin',
      role: 'ADMIN',
      authorisedPages: ['Product', 'Admin', 'User', 'DataUpload', 'Price', 'Report',
      'Customer', 'Inventory', 'Payment', 'Invoice', 'Enquiry', 'Offer', 'Order', 'UploadFile'
      // ,'INV'
    // , 'POffer'
    ],
    };
    localStorage.setItem('user', JSON.stringify(user));
    navigate('/dashboard', { state: { user } });
    return;
  }

  // ✅ Otherwise try backend login
  try {
    const res = await axios.post(`${API_BASE}/login`, { username, password });

    if (res.data.status === 'success') {
      const user = res.data.user;
      user.authorisedPages = res.data.authorisedPages;
      localStorage.setItem('user', JSON.stringify(user));
      navigate('/dashboard', { state: { user } });
    } else {
      setError(res.data.message || 'Invalid username or password.');
    }
  } catch (err) {
    if (err.response && err.response.status === 401) {
      setError('Invalid username or password.');
    } else {
      setError('Server error. Please try again later.');
    }
  }
};


  return (
    <div style={{ textAlign: 'center', marginTop: '100px' }}>
      <h2>Login</h2>
      <form onSubmit={handleLogin}>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <br /><br />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <br /><br />
        <button type="submit">Login</button>
        {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
      </form>
    </div>
  );
}

export default Login;
